// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__2biKx","welcome-msg":"Logo_welcome-msg__2QKGu","demo":"Logo_demo__2E9zX"};